<template>
  <div class="Search-modal-window">
    <div @click="openModal" >
      <img class="search" :src="require('@/assets/estate_icon/pc/' + imgSrc)">
    </div>

    <SearchModal @close="closeModal" v-if="searchmodal">
    </SearchModal>
  </div>
</template>

<script>
import SearchModal from '@/components/SearchModal.vue'
export default {
  name: 'SearchButton',
  props: {
    imgSrc: String
  },
  components: {
    SearchModal
  },
  data () {
    return {
      searchmodal: false
    }
  },
  methods: {
    openModal () {
      this.searchmodal = true
      document.getElementById('pc-header').style.height = '100vh'
    },
    closeModal () {
      this.searchmodal = false
      document.getElementById('pc-header').style.height = '8vh'
    }
  }
}
</script>

<style lang="scss">
  .search{
    height: 1.6vh;

    img{
      cursor: pointer;
    }
    @media (max-width: 550px) {
      height: 20px;
    }
  }
</style>
